import { Injector } from '@angular/core';
import { ANALYSIS_PLAN_LIST_APP_STATE_SLICE_KEY, ANALYSIS_PLAN_LIST_STATE_KEYS } from '../state/constants';
import { AppStateService } from 'NewAngular/services/app-state.service';
import { AppStateManager } from 'NewAngular/services/app-state-manager.service';
import * as i0 from "@angular/core";
export class SavedAnalysisPlanListAppStateManager extends AppStateManager {
    // AppStateService is lazily resolved to avoid a circular dependency: this service is
    // providedIn: 'root' and AppStateService depends on ActivatedRoute, which isn't available
    // on pages without a Router (e.g. quote pages that import HypotheticalsSharedModule).
    constructor(injector) {
        super(null);
        this.injector = injector;
    }
    resolveAppStateService() {
        if (this.appStateService === null) {
            this.appStateService = this.injector.get(AppStateService, null);
        }
    }
    initAppState() {
        this.resolveAppStateService();
        if (!this.appStateService)
            return;
        this.appStateService.setStateSlice(ANALYSIS_PLAN_LIST_APP_STATE_SLICE_KEY);
        this.appStateService.setUrlParamKeys(ANALYSIS_PLAN_LIST_STATE_KEYS);
        this.appStateService.start();
    }
}
SavedAnalysisPlanListAppStateManager.ɵfac = function SavedAnalysisPlanListAppStateManager_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SavedAnalysisPlanListAppStateManager)(i0.ɵɵinject(i0.Injector)); };
SavedAnalysisPlanListAppStateManager.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: SavedAnalysisPlanListAppStateManager, factory: SavedAnalysisPlanListAppStateManager.ɵfac, providedIn: 'root' });
